module.exports = __webpack_public_path__ + "static/media/afford.8c333e8f.png";